module.exports = __webpack_public_path__ + "static/img/salesPlatform3.b33b35a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Parters/salesPlatform3.png
// module id = CPEu
// module chunks = 1